import { createAction, createReducer } from '../../helpers/redux';

const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';

export const setIsAuthenticated = createAction(SET_IS_AUTHENTICATED);

export const isAuthenticated = createReducer(false, (state, { value }) => ({
    [SET_IS_AUTHENTICATED]: () => value,
}));
